import { Fragment, useState, useRef } from 'react';

import { useSelector } from 'react-redux';

import CircularProgress from '@material-ui/core/CircularProgress';

import classes from './AddProperty.module.css';
import ModalLayout from './ModalLayout';
import PropertyItem from './PropertyItem';

import close from '../../assets/img/closeIcon.svg';
import ConfirmationModal from '../../Components/UIHeader/ConfirmationModal';
import Header from '../UIHeader/Header';

const sortingBasedOnOptionOrder = (options) => {
  return options?.sort((a, b) => a.optionOrder - b.optionOrder);
};

const AddProperty = ({ hideModal }) => {
  const { data } = useSelector((state) => state.optRed);
  const options = data?.options || data?.optionProviderRequestList;
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [title, setTitle] = useState('');
  const [msg, setMsg] = useState('');
  const [inProgress, setInprogress] = useState(false);
  const timer = useRef(null);

  const [optionProviderRequestList] = useState(sortingBasedOnOptionOrder(options));

  const onShortListed = (mode) => {
    timer.current && clearTimeout(timer.current);

    if (mode === 'ADD') {
      setTitle('Successfully added');
      setMsg('This property has been successfully added to shortlisted properties');
    }

    if (mode === 'REMOVE') {
      setTitle('Successfully removed');
      setMsg('This property has been removed successfully from shortlisted properties');
    }

    setShowConfirmation(true);
    timer.current = setTimeout(() => {
      setShowConfirmation(false);
    }, 8000);
  };

  const closeConfirmationModal = () => {
    setShowConfirmation(false);

    timer.current && clearTimeout(timer.current);
  };

  const setProgress = (val) => {
    setInprogress(val);
  };

  return (
    <Fragment>
      {showConfirmation && (
        <ConfirmationModal msg={msg} title={title} onClose={closeConfirmationModal} />
      )}
      <ModalLayout hideModal={hideModal}>
        <h2>Add Property</h2>
        <img src={close} className={classes.close} onClick={hideModal} />
        <div className={classes['properties__container']}>
          {optionProviderRequestList?.length > 0 &&
            optionProviderRequestList?.map((option) => (
              <PropertyItem
                option={option}
                key={'addProp_' + option.id}
                onShortListed={onShortListed}
                inProgressV={setProgress}
              />
            ))}
        </div>
        {inProgress && (
          <span className={classes.spinner}>
            <CircularProgress color="inherit" />
          </span>
        )}
      </ModalLayout>
    </Fragment>
  );
};

export default AddProperty;
